import React, { Component } from "react";
import client from "../../../utils/client";
import { Link, withRouter } from "react-router-dom";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import perforatedBorderBlue from "../../../assets/perforated-border-blue.svg";
// import wrpIcon from "../../../assets/wrp-icon-gold.svg";
import lightningIcon from "../../../assets/lightning-icon.svg";
import deliverWithDelayIcon from "../../../assets/delivery-van-icon.svg";
import { connect } from "react-redux";
// import lodash from "lodash";
import { setVoucher, setDenomination, setQuantity, setWallet } from "../actions";
import ContentLoader from "react-content-loader";
import { FormattedMessage, injectIntl } from "react-intl";
import bookmarkActive from "../../../assets/bookmark-active.svg";
import bookmarkInactive from "../../../assets/bookmark-inactive.svg";
import saveicon from "../../../assets/ic_save.svg"
import aboutBlue from "../../../assets/about-blue.svg";
import VoucherWrpModal from "../../../components/VoucherWrpModal";
import ReferNowSection from "../../../components/ReferNowSection";
import clientX from "../../../utils/clientX";
import classNames from "classnames";
import { currentlySelectedLanguage } from "../../../utils/helper";
import { onViewedProduct } from "../../../utils/events";
import Iframe from "../../../components/iFrame";
import { FirebaseContext } from "../../../utils/firebase";
import Modal from "react-bootstrap/Modal";

class VoucherDetail extends Component {
  static contextType = FirebaseContext;

  constructor(props) {
    super(props);

    this.state = {
      voucher: null,
      amount: 0,
      isLoading: true,
      isWrpBenefitModelOpen: false,
      isVoucerMaintenance: false,
      show:false,
      walletSelected:false
    };
  }

  handleShow = () => {
    this.setState({ show: true });
  };

  handleHide = () => {
    this.setState({ show: false });
  };

  componentDidMount() {
    this.props.setDenomination(undefined);
    const { voucher_detail } = this.context;
    if (!voucher_detail) {
      const {
        match: { params },
      } = this.props;
      this.setState(
        {
          isLoading: true,
        },
        () => {
          client.get(`v1/vouchers/${params.id}`).then((response) => {
            let data = response.data.data;
            const payload = {
              Category: "Voucher",
              "Product Name": data.name,
            };
            onViewedProduct(payload);
            this.setState({
              voucher: data,
              key: "details",
              isLoading: false,
            });
            if(data.wallet_info && data.wallet_info.balance>0){
              this.setState({walletSelected:true})
            }
            this.props.setVoucher(data);
          });
        }
      );
    } else {
      this.setState({
        isVoucerMaintenance: voucher_detail,
      });
    }
  }

  handleWallet = (e) => {
    this.setState({ walletSelected: e.target.checked})
  }

  openWrpBenefitModel = () => {
    this.setState({ isWrpBenefitModelOpen: true });
  };

  closeWrpModelHandler = () => {
    this.setState({ isWrpBenefitModelOpen: false });
  };

  toggleBookmark = (event, id, isBookmarked) => {
    event.preventDefault();
    event.stopPropagation();
    this.onToggleBookmark(id, isBookmarked, `/v1/vouchers/${id}/bookmark`);
  };

  onToggleBookmark = (id, isBookmarked, url) =>
    !isBookmarked
      ? this.addBookmark(id, url, this.props.vouchers)
      : this.deleteBookmark(id, url, this.props.vouchers);

  addBookmark = (id, url, vouchers) => {
    clientX
      .post(url, {})
      .then((response) => {
        this.setState((prevState) => ({
          voucher: {
            ...prevState.voucher,
            bookmarked: !prevState.voucher.bookmarked,
          },
        }));
      })
      .catch((error) => { });
  };

  deleteBookmark = (id, url, vouchers) => {
    clientX
      .delete(url)
      .then((response) => {
        this.setState((prevState) => ({
          voucher: {
            ...prevState.voucher,
            bookmarked: !prevState.voucher.bookmarked,
          },
        }));
      })
      .catch((error) => { });
  };

  onSelectDenomination = (event) => {
    let denomination = this.state.voucher.denominations.filter(
      (item, index) => {
        return parseInt(item.id) === parseInt(event.target.value);
      }
    );
    if (denomination && denomination[0] && denomination[0].value)
      this.setState({ amount: denomination[0].value });
    else
    this.setState({ amount: 0 });
    this.props.setDenomination(denomination[0]);
  };

  onEnterAmount = (event) => {
    this.setState({ amount: event.target.value });

    this.props.setDenomination({
      id: this.state.voucher.denominations[0].id,
      value: event.target.value,
    });
  };

  onIncreaseQuantity = () => {
    this.props.setQuantity(this.props.quantity + 1);
  };

  onDecreaseQuantity = () => {
    if (this.props.quantity > 1) {
      this.props.setQuantity(this.props.quantity - 1);
    }
  };

  onProceed = () => {
    if ("range" === this.state.voucher.voucher_type) {
      if (
        this.state.amount >
        parseInt(this.state.voucher.denominations[0].max_value) ||
        this.state.amount <
        parseInt(this.state.voucher.denominations[0].min_value)
      ) {
        toast.error(this.getInstruction(), {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        return;
      }
    }
    this.props.setWallet(this.state.walletSelected);
    this.props.history.push("/vouchers/cart");
  };

  render() {
    return this.context.voucher_detail ? (
      <div className="container-fluid font-proxima-nova">
        <this.BreadCrubs />
        <Iframe
          source={`${process.env.REACT_APP_BASE_URL_VOUCHER_MAINTENANCE
            }/${currentlySelectedLanguage()}`}
        ></Iframe>
      </div>
    ) : this.state.isLoading ? (
      <this.Shimmer />
    ) : (
      <this.Voucher />
    );
  }

  Shimmer = (props) => {
    return (
      <div className="container-fluid py-3 py-md-5">
        <div className="row">
          <div className="col-md-6">
            <div className="box shine box-voucher-detail-logo"></div>
          </div>
          <div className="col-md-6 pt-4 pt-md-0">
            <ContentLoader
              height={80}
              width={400}
              speed={2}
              primaryColor="#f3f3f3"
              secondaryColor="#ecebeb"
            >
              <rect x="0" y="0" rx="2" ry="2" width="99" height="6" />
              <rect x="0" y="16" rx="2" ry="2" width="300" height="24" />
            </ContentLoader>
            <div className="box shine w-100" style={{ height: "38px" }}></div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <ContentLoader
              height={160}
              width={400}
              speed={2}
              primaryColor="#f3f3f3"
              secondaryColor="#ecebeb"
            >
              <rect x="0" y="9" rx="0" ry="0" width="120" height="6" />
              <rect x="0" y="21" rx="0" ry="0" width="320" height="12" />
              <rect x="0" y="39" rx="0" ry="0" width="92" height="6" />
              <rect x="0" y="60" rx="0" ry="0" width="506" height="6" />
              <rect x="0" y="75" rx="0" ry="0" width="136" height="6" />
              <rect x="0" y="90" rx="0" ry="0" width="153" height="6" />
            </ContentLoader>
          </div>
          <div className="col-md-6"></div>
        </div>
      </div>
    );
  };

  BreadCrubs = () => {
    return (
      <div className="row mt-3 mb-3 mt-md-4 mb-md-4">
        <div className="col-12">
          <div className="row align-items-center">
            <div className="col-12">
              <small>
                <Link to="/">
                  <FormattedMessage
                    id="breadcrumbs.home"
                    defaultMessage="Home"
                  />
                </Link>
              </small>{" "}
              /{" "}
              <small>
                <Link to="/vouchers">
                  <FormattedMessage
                    id="home.vouchers"
                    defaultMessage="Vouchers"
                  />
                </Link>
              </small>{" "}
              {this.state.voucher && (
                <React.Fragment>
                  /{" "}
                  <small>
                    <strong>{this.state.voucher.name}</strong>
                  </small>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  Voucher = (props) => {
    return (
      <div className="container-fluid font-proxima-nova">
        {/* <this.BreadCrubs /> */}
        {this.BreadCrubs()}
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-md-6">
                {/* <this.VoucherImage /> */}
                {this.VoucherImage()}
              </div>
              <div className="col-md-6">
                {/* <this.Controls /> */}
                {this.Controls()}
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-2 mt-md-5">
          <div className="col-12">
            <hr />
          </div>
        </div>
        <div className="row mb-md-4 mb-5">
          <div className="col-12 col-md-7 mt-2 mt-md-5">
            {/* <this.Details /> */}
            {this.Details()}
          </div>
          <div className="col-md-5 d-none d-md-none mt-5">
            <ReferNowSection />
          </div>
        </div>
      </div>
    );
  };

  getInstruction = () => {
    const language = currentlySelectedLanguage();
    switch (language) {
      case "en":
        return `Pick an amount between ${this.state.voucher.denominations[0].min_value} and ${this.state.voucher.denominations[0].max_value}`;
      case "hi":
        return `${this.state.voucher.denominations[0].min_value} से ${this.state.voucher.denominations[0].max_value} के बीच की राशि चुनें`;
      case "gu":
        return `${this.state.voucher.denominations[0].min_value} અને ${this.state.voucher.denominations[0].max_value} ની વચ્ચે રકમ પસંદ કરો`;
      case "bn":
        return `${this.state.voucher.denominations[0].min_value} এবং ${this.state.voucher.denominations[0].max_value} এর মধ্যে একটি পরিমাণ বাছাই করুন`;
      case "kn":
        return `${this.state.voucher.denominations[0].min_value} ಮತ್ತು ${this.state.voucher.denominations[0].max_value} ರ ನಡುವೆ ಮೊತ್ತವನ್ನು ಆರಿಸಿ`;
      case "ml":
        return `${this.state.voucher.denominations[0].min_value} നും ${this.state.voucher.denominations[0].max_value} നും ഇടയിൽ ഒരു തുക തിരഞ്ഞെടുക്കുക`;
      case "mr":
        return `পিচক ামোুনত বেতৱৈন ${this.state.voucher.denominations[0].min_value}  ানদ ${this.state.voucher.denominations[0].max_value}`;
      case "or":
        return `${this.state.voucher.denominations[0].min_value} ରୁ ${this.state.voucher.denominations[0].max_value} ମଧ୍ୟରେ ପରିମାଣ ବାଛନ୍ତୁ `;
      case "ta":
        return `${this.state.voucher.denominations[0].min_value} முதல் ${this.state.voucher.denominations[0].max_value} வரை ஒரு தொகையைத் தேர்ந்தெடுக்கவும்`;
      case "te":
        return `${this.state.voucher.denominations[0].min_value} మరియు ${this.state.voucher.denominations[0].max_value} మధ్య మొత్తాన్ని ఎంచుకోండి`;

      default:
        return `Pick an amount between ${this.state.voucher.denominations[0].min_value} and ${this.state.voucher.denominations[0].max_value}`;
    }
  };

  VoucherImage = (props) => {
    const {
      bookmarked,
      id,
      image_url,
      delivery_type,
      name,
      turn_around_time_in_hours,
      // winds_rating,
    } = this.state.voucher;
    return (
      <div
        className="card"
        style={{
          boxShadow: "0 4px 30px 0 rgba(0,0,0,0.08)",
          borderRadius: "8px",
          border: "none",
        }}
      >
        <div
          className="card-body"
          style={{ backgroundColor: "#EFF6FF", borderRadius: "8px 8px 0 0" }}
        >
          <div className="row align-items-center">
            {
              <img
                src={bookmarked ? bookmarkActive : bookmarkInactive}
                className="bookmark"
                alt=""
                onClick={(event) => this.toggleBookmark(event, id, bookmarked)}
              />
            }
            <div className="col-4 col-md-3">
              <div
                className="voucher-detail-logo-wrapper"
                style={{
                  backgroundImage: `url(${image_url})`,
                }}
              ></div>
            </div>
            <div className="col-8 col-md-9">
              <div className="row">
                <div className="col-12">
                  <span className="voucher-deliveryType">{delivery_type}</span>
                  <h4 className="voucher-title">
                    <strong>{name}</strong>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="card-footer pt-4 pb-4"
          style={{
            background: "#fff",
            border: "none",
            borderRadius: "0 0 8px 8px",
            backgroundImage: `url(${perforatedBorderBlue})`,
            backgroundRepeat: "repeat-x",
            backgroundPositionX: "-2px",
          }}
        >
          <div className="row font-proxima-nova align-items-center">
            <div className="col-7">
              {0 === parseInt(turn_around_time_in_hours) ? (
                <p className="mb-0 voucher-delivery-detail">
                  <img src={lightningIcon} alt="" />
                  Instant Delivery
                </p>
              ) : (
                <p className="mb-0 voucher-delivery-detail">
                  <img src={deliverWithDelayIcon} alt="" />
                  <FormattedMessage
                    id="voucher.delivered-in"
                    defaultMessage="Delivered in"
                  />{" "}
                  {turn_around_time_in_hours}{" "}
                  {turn_around_time_in_hours > 1 ? "Hours" : "Hour"}
                </p>
              )}
            </div>
            <div className="col-5 voucher-delivery-detail text-right">
              {
                this.state.voucher.customer_discount > 0 ?
                <p className="mb-0">Avail Discount {this.state.voucher.customer_discount}%</p>:
                <></>
              }
              
          
            </div>
          </div>
        </div>
      </div>
    );
  };

  Controls = (props) => {
    const { wrp_ratio, voucher_type, denominations } = this.state.voucher;
    const { isWrpBenefitModelOpen } = this.state;
    const { denomination, quantity } = this.props;
    return (
      <React.Fragment>
        <div className="row align-items-center mt-5 mt-md-0">
          <div className="col-8 col-md-6">
            <div className="form-group">
              <label htmlFor="denomination">
                <FormattedMessage id="general.amount" defaultMessage="Amount" />
              </label>
              {"fixed" === voucher_type ? (
                <select
                  className="form-control"
                  id="denomination"
                  onChange={this.onSelectDenomination}
                >
                  <option value="-1">
                    {this.props.intl.formatMessage({
                      id: "vouchers.choose-denomination",
                    })}
                  </option>
                  {denominations.map((item, index) => {
                    return (
                      <option
                        key={"voucher-denomination-" + index}
                        value={item.id}
                      >
                        {item.value}
                      </option>
                    );
                  })}
                </select>
              ) : (
                <React.Fragment>
                  <input
                    type="number"
                    className="form-control"
                    placeholder={this.props.intl.formatMessage({
                      id: "vouchers.enter-amount",
                    })}
                    onChange={this.onEnterAmount}
                  />
                  <small className="form-text text-muted">
                    {/* <this.getInstruction /> */}
                    {this.getInstruction()}
                  </small>
                </React.Fragment>
              )}
            </div>
          </div>
          <div className="col-4 col-md-6 text-right">
            <div
              className={classNames(
                "align-middle",
                { "mb-3": "range" === voucher_type },
                { "mt-3": "fixed" === voucher_type }
              )}
            >
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                style={{
                  height: "25px",
                  width: "25px",
                  lineHeight: "16px",
                  borderRadius: "50%",
                }}
                onClick={this.onDecreaseQuantity}
              >
                -
              </button>
              <span className="mr-2 ml-2">{quantity}</span>
              <button
                className="btn btn-primary btn-sm"
                type="submit"
                style={{
                  height: "25px",
                  width: "25px",
                  lineHeight: "16px",
                  borderRadius: "50%",
                }}
                onClick={this.onIncreaseQuantity}
              >
                +
              </button>
            </div>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-12">
          {this.state.voucher.customer_discount>0? 
            <>
              <h6>Get it for Rs. {(this.state.amount)-((this.state.voucher.customer_discount*this.state.amount)/100)}</h6>
              <div className="terms-box d-flex justify-content-between">
                <h6 style={{color:"#820da0",display:"flex",alignItems:"center"}}><img src={saveicon} width="25px" style={{marginRight:"3px"}} alt="save-money" />You Save Rs. {(this.state.voucher.customer_discount*this.state.amount)/100}</h6>
                <h6 style={{color:"rgb(37 13 171)",cursor:"pointer"}} onClick={this.handleShow}>{this.props.intl.formatMessage({ id: "footer.terms-and-conditions"})}</h6>
              </div>
            </>
            :
              <>
              <div className="terms-box d-flex justify-content-end">
                <h6 style={{color:"rgb(37 13 171)",cursor:"pointer"}} onClick={this.handleShow}>{this.props.intl.formatMessage({ id: "footer.terms-and-conditions"})}</h6>
              </div></>
            }
            {/* {this.state.voucher.wallet_info ?
            <div className="custom-control custom-checkbox ml-auto">
            <input
              type="checkbox"
              className="custom-control-input"
              id="wallet"
              onChange={(e) => this.handleWallet(e, "wallet")}
              name="wallet"
              checked={this.state.walletSelected}
              disabled = {this.state.voucher.wallet_info.balance === 0 || this.state.voucher.wallet_info === null}
            />
            <label
              className="custom-control-label"
              htmlFor="wallet"
            >Wallet Balance  -  Rs {this.state.voucher.wallet_info.balance}</label>
          </div>:
          <></>
            } */}
            
          </div>
        </div>

        <Modal size="lg" aria-labelledby="contained-modal-title-vcenter" centered show={this.state.show} onHide={this.handleHide}>
          <Modal.Header>
            <Modal.Title>
              <FormattedMessage
                id="navbar.Terms-and-Conditions"
                defaultMessage="Terms and Conditions"
              />
            </Modal.Title>
            <button type="button" className="close" onClick={this.handleHide}>
              <span aria-hidden="true">×</span>
              <span className="sr-only">Close</span>
            </button>
          </Modal.Header>
          <Modal.Body>
          <div
            style={{
              color: "#646464 !important",
              fontSize: "16px",
              linHeight: "1.5em",
            }}
            dangerouslySetInnerHTML={{ __html: this.state.voucher.terms }}
          />
          </Modal.Body>
        </Modal>

        <div className="row mt-3 align-items-center">
          <div className="col-12">
            {denomination && quantity > 0 ? (
              <button
                className="btn btn-primary btn-block mb-3"
                style={{
                  padding: ".8rem 0",
                  fontSize: ".8rem",
                  letterSpacing: ".1rem",
                }}
                onClick={this.onProceed}
              >
                <FormattedMessage
                  id="general.proceed"
                  defaultMessage="PROCEED"
                />
              </button>
            ) : (
              <button
                className="btn btn-primary btn-block mb-3"
                style={{
                  padding: ".8rem 0",
                  fontSize: ".8rem",
                  letterSpacing: ".1rem",
                }}
                disabled={true}
              >
                <FormattedMessage
                  id="general.proceed"
                  defaultMessage="PROCEED"
                />
              </button>
            )}
            <button
              className="btn btn-outline mt-1 mt-md-3"
              style={{ color: "#087CD8" }}
              onClick={this.openWrpBenefitModel}
            >
              <img src={aboutBlue} alt="" className="mr-1" />{" "}
              <FormattedMessage
                id="general.wrp_benefits"
                defaultMessage="WRP Benefits"
              />
            </button>
          </div>
          {isWrpBenefitModelOpen && (
            <VoucherWrpModal
              isWrpBenefitModelOpen={isWrpBenefitModelOpen}
              wrp_ratio={wrp_ratio}
              closeWrpModelHandler={this.closeWrpModelHandler}
            />
          )}
        </div>
      </React.Fragment>
    );
  };

  Details = (props) => {
    const { key, voucher } = this.state;
    return (
      <Tabs
        className="wrp-tabs"
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(selectedKey) => this.setState({ key: selectedKey })}
      >
        <Tab
          eventKey="details"
          title={this.props.intl.formatMessage({ id: "general.how_to_redeem" })}
        >
          <img src={voucher.redeem_image_path} width="100%" style={{padding:"3%"}} alt="redeem" />
          <div
            style={{
              color: "#646464",
              fontSize: "16px",
              linHeight: "22px",
              paddingTop: "30px",
            }}
            dangerouslySetInnerHTML={{ __html: voucher.redeem_text }}
          />
        </Tab>
        <Tab
          eventKey="terms"
          title={this.props.intl.formatMessage({ id: "general.details" })}
        >
          <div
            style={{
              color: "#646464 !important",
              fontSize: "16px",
              linHeight: "1.5em",
              marginTop: "2rem",
            }}
            dangerouslySetInnerHTML={{ __html: voucher.description }}
          />
        </Tab>
      </Tabs>
    );
  };
}

function mapStateToProps(state) {
  return {
    voucher: state.voucher.voucher,
    denomination: state.voucher.denomination,
    quantity: state.voucher.quantity,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setVoucher: (id) => {
      dispatch(setVoucher(id));
    },
    setDenomination: (denomination) => {
      dispatch(setDenomination(denomination));
    },
    setQuantity: (quantity) => {
      dispatch(setQuantity(quantity));
    },
    setWallet: (wallet) => {
      dispatch(setWallet(wallet));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(withRouter(VoucherDetail)));